import { getEnvDetails } from './config';


export const getS3KeyPath = ({ id, type }, env) => {
  const {
    bucket,
    basePath,
    productKey
  } = getEnvDetails(id, type, env);

  const KeyPath = `${ bucket }/${ basePath }/${ productKey }/content/${ id }`;

  return KeyPath;
};


export const generateS3Key = ({ id, type }, env) => {
  const keyPath = getS3KeyPath({ id, type }, env);

  const Key = `${ keyPath }/${ id }.json`;

  return Key;
};
